import Cookies from 'js-cookie'

const NavigatorLang = (navigator.language || navigator.userLanguage).substr(0, 2)
const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  lang: Cookies.get('UserLang') || NavigatorLang,
  headerMenuShow: false
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  TOGGLE_HeaderMenuShow: state => {
    state.headerMenuShow = !state.headerMenuShow
  },
  CLOSE_HeaderMenuShow: state => {
    state.headerMenuShow = false
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  UPDATE_LANG(state, value) {
    state.lang = value
    localStorage.setItem('UserLang', state.lang)
    Cookies.set('UserLang', state.lang)
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  toggleHeaderMenuShow({ commit }) {
    commit('TOGGLE_HeaderMenuShow')
  },
  colseHeaderMenuShow({ commit }) {
    commit('CLOSE_HeaderMenuShow')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setLang({ commit }, lang) {
    commit('UPDATE_LANG', lang)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
